import React from "react";
import { useTranslation } from "next-i18next";
import style from "../../../styles/mystyle.module.css";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import dynamic from "next/dynamic";
import { CustomeSuperTab , CustomeTab } from "./DetailsMedical.style"
const Certificates = dynamic(() => import('./Certificates'),{ssr:false})
const WorkTime = dynamic(() => import('./WorkTime'),{ssr:false})
const EntityProducts = dynamic(() => import('./EntityProducts'),{ssr:false})
const EntityAddress = dynamic(() => import('./EntityAddress'),{ssr:false})
const Specialty = dynamic(() => import('./Specialty'),{ssr:false})
const AboutDoctor = dynamic(() => import('./AboutDoctor'),{ssr:false})
const ArticalSlider = dynamic(() => import('../Blog/ArticalSlider'),{ssr:false})
const Cards = dynamic(() => import('./Cards'),{ssr:false})
const Departments = dynamic(() => import('./Departments'),{ssr:false})
const Clinic = dynamic(() => import('./Clinic'),{ssr:false})
const DoctorFacility = dynamic(() => import('./DoctorFacility'),{ssr:false})
const Devices = dynamic(() => import('./Devices'))
const Insurancecompanies = dynamic(() => import('./Insurancecompanies'),{ssr:false})
function TabsMedical({ entityId, pid,
    majors,
    address
    , blog, StatusIds,
    productCategories,
    blogTypes, showClinics, showDepartments,
    entityDetailsData,
    infoTab,
    workTimes,
    days ,...props}) {


    const [value, setvalue] = React.useState(null);

    const handleChange = (event, newValue) => {
        setvalue(newValue);
    };

    const { t } = useTranslation("common");

    return (
        <div>
            <div className={style.SectionContainer}>
                <div className={style.allcard}>

                    <TabContext value={value || infoTab}>
                        <div>

                            <div className={style.stylesTabsFav}>
                                <CustomeSuperTab
                                    value={value || infoTab}
                                    onChange={handleChange}
                                    variant="scrollable"
                                    TabIndicatorProps={{
                                        style: { backgroundColor: "white", height: "0" }
                                    }}
                                >
                                    <CustomeTab
                                        sx={{
                                            boxShadow:
                                                (infoTab == '1' && value == null) || value == 1 ? "5px 2px 9px 1px #bcbcbc" : "none"
                                        }}
                                        label={t("ttlAbout")}
                                        value="1"
                                    />
                                    <CustomeTab
                                        sx={{
                                            boxShadow:
                                                value == "2" ? "5px 2px 9px 1px #bcbcbc" : "none"
                                        }}
                                        label={t("Products")}
                                        value="2"
                                    />
                                    <CustomeTab
                                        sx={{
                                            boxShadow:
                                                value == "3" ? "5px 2px 9px 1px #bcbcbc" : "none"
                                        }}
                                        label={t("Blogs")}
                                        value="3"
                                    />
                                    <CustomeTab
                                        sx={{
                                            boxShadow:
                                                value == "4" ? "-7px 0px 9px 1px #bcbcbc " : "none"
                                        }}
                                        label={t("ttlEntities")}
                                        value="4"
                                    />
                                    <CustomeTab
                                        sx={{
                                            boxShadow:
                                                value == "5" ? "-7px 0px 4px 0px #bcbcbc " : "none",
                                            '&.Mui-selected': {
                                                border: "none"
                                            },

                                        }}
                                        label={t("Devices")}
                                        value="5"
                                    />
                                </CustomeSuperTab>
                            </div>

                        </div>
                        <div>
                    
                            <TabPanel
                                padding={"0px !important"}
                                sx={{ padding: 0 }}
                                value="1"
                            >

                                {entityId ?
                                        <AboutDoctor entityId={entityId} blog={blog} StatusIds={StatusIds} />
                                        : ""
                                }
                                <EntityAddress entityId={entityId} pid={pid}
                                    address={address}
                                />
                                {
                                    <Specialty entityId={entityId} majors={majors} />
                                }
                            
                                {
                                    
                                    <WorkTime entityId={entityId} StatusIds={StatusIds} days={days} workTimes={workTimes} />
                                }
                                {
                                    <Certificates entityId={entityId} statusIds={StatusIds} />
                                }
             
                            </TabPanel>
                        </div>
                        <TabPanel padding="0px !important" value="2" sx={{ padding: 0 }}>
                            <EntityProducts entityId={entityId}
                             statusIds={StatusIds}
                             productCategories={productCategories}
                             entityDetails={entityDetailsData} 
                             exchangeCurrenciesRes={props.exchangeCurrenciesRes}
                             currencies={props.currencies}
                             />
                        </TabPanel>
                        <TabPanel padding="0px !important" value="3" sx={{ padding: 0 }}>
                            <ArticalSlider entityId={entityId} ShowHeader={true} StatusIds={StatusIds} blogTypesLst={blogTypes}
                                title={t("Blogs")}
                                entityDetails={entityDetailsData}
                            />
                        </TabPanel>
                        <TabPanel padding="0px !important" value="4" sx={{ padding: 0 }}>
                            <Cards entityId={entityId} pid={pid} StatusIds={StatusIds} days={days} showSeeMoreLink={true}/>
                            <DoctorFacility pid={pid} StatusIds={StatusIds} days={days} />
                            <Insurancecompanies entityId={entityId} pid={pid} StatusIds={StatusIds} days={days} />
                            {
                                showClinics ?
                                    <Clinic entityId={entityId} pid={pid} days={days} StatusIds={StatusIds} entityDetails={entityDetailsData} /> //parent
                                    : ""
                            }
                            {
                                showDepartments ?
                                    <Departments entityId={entityId} pid={pid} days={days} StatusIds={StatusIds} entityDetailsData={entityDetailsData} />//parent
                                    : ""
                            }
                        </TabPanel>
                        <TabPanel padding="0px !important" value="5" sx={{ padding: 0 }}>
                            <Devices
                                entityId={entityId}
                                StatusIds={StatusIds}
                                entityDetailsData={entityDetailsData}
                            />
                        </TabPanel>
                    </TabContext>
                </div>
            </div>
        </div>
    );
}

export default TabsMedical;
